export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";